<template>
    <div class="mx-auto max-w-md">
        <div class="px-4 py-2 border-b sticky top-0 bg-white ">
            <input
            v-model="search"
            type="search"
            class="form-input mx-auto max-w-md"
            placeholder="Søg efter areal"
        />
        </div>
        <LoadingIndicator v-if="arealer == undefined" class="w-full h-10 my-10 text-gray-700 mx-auto" />
        <div class="text-center p-4 font-semibold" v-if="arealer && filteredArealer.length == 0">Ingen arealer matcher din søgning</div>
        <ul v-if="arealer" class=" ">
            <ArealBookings class=" border-b" v-for="a in filteredArealer" :key="a.id" :areal="a" />
        </ul>
    </div>
</template>

<script>
import ArealBookings from "./ArealBookings.vue";
import LoadingIndicator from "./LoadingIndicator.vue";
export default {
    name: "Liste",
    components: {
    ArealBookings,
    LoadingIndicator
},
    data() {
        return {
            arealer: undefined,
            search: ""
        }
    },
    created() {
        this.getBookinger();
    },
    methods: {
        async getBookinger() {
            this.arealer = await fetch(process.env.VUE_APP_API_URL + "/api/Arealer")
            .then(res => res.json())
            .then(response => response.features.sort((a, b) => a.properties.navn.toLowerCase().localeCompare(b.properties.navn.toLowerCase(), 'da')))
        }
    },
    computed: {
        filteredArealer() {
            if (this.arealer) {
                return this.arealer.filter(areal =>
                    areal.properties.navn.toLowerCase().includes(this.search.toLowerCase().trim())
                )
            }
            else return []
        }
    }
}
</script>